import { render, staticRenderFns } from "./publicar-sumario.vue?vue&type=template&id=b9f2dc50&"
import script from "./publicar-sumario.vue?vue&type=script&lang=js&"
export * from "./publicar-sumario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports